import { LicenseInfo } from "@mui/x-license";
import { env } from "./utils/env";
import { sanitizeLog } from "./utils/logSanitizer";

/**
 * Configures MUI X Pro license key
 * This enables MUI X Pro features like DataGridPro with infinite scrolling
 * If no license key is provided, MUI X will use the free tier
 * Errors during license validation are logged but do not prevent app initialization
 */
export const configureMuiXLicense = () => {
  if (env.VITE_MUI_X_LICENSE_KEY) {
    try {
      LicenseInfo.setLicenseKey(env.VITE_MUI_X_LICENSE_KEY);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(
        "Failed to set MUI X license key:",
        sanitizeLog(error instanceof Error ? error.message : String(error))
      );
    }
  }
};
